import { useAccountingStore } from '@/stores/accounting';
import ROUTES from '@/utils/constants/accounting_routes_constants';
import USER_PERMISSIONS from '@/utils/constants/accounting_permissions_constants';

const actions = [
    {
        routeName: ROUTES.GL_JOURNAL_ENTRIES.name,
        items: [
            {
                title: 'add new entries',
                routeName: ROUTES.GL_JOURNAL_ENTRIES_ADD_NEW_ENTRIES.name,
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_ADD_JOURNAL_ENTRY);
                },
            },
        ],
    },
];

export default actions;
